import { CircleHelp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from "@/components/ui/tooltip";

// Small inline help affordance: a ghost icon button that reveals a single,
// concise sentence explaining what a feature does. Keep copy <= 120 chars,
// plain language, no jargon (per "The Andy Principle").
export const HelpHint = ({ text, testId }) => (
  <TooltipProvider delayDuration={150}>
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="h-8 w-8 rounded-md text-muted-foreground hover:text-foreground"
          data-testid={testId || "help-hint-trigger"}
          aria-label="Help"
        >
          <CircleHelp className="h-4 w-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent data-testid="help-hint-content" className="max-w-[220px] text-xs">
        {text}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
